import React from "react";

// Custom logo for World Wide Wholesale Deals LLC
// Globe + stacked boxes icon paired with wordmark
export default function Logo({ variant = "dark", compact = false, dense = false }) {
  const primary = variant === "light" ? "#ffffff" : "#16233f";
  const teal = "#f5b301";
  const iconSize = dense ? 38 : 46;
  const line1 = dense ? "12.5px" : "15px";
  const line2 = dense ? "14px" : "17px";

  return (
    <div className="flex items-center gap-2.5 select-none">
      <svg
        width={iconSize}
        height={iconSize}
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0"
      >
        {/* Globe */}
        <circle cx="32" cy="28" r="20" fill={teal} opacity="0.14" />
        <circle cx="32" cy="28" r="14" stroke={teal} strokeWidth="2.4" fill="none" />
        <ellipse cx="32" cy="28" rx="5.5" ry="14" stroke={teal} strokeWidth="2" fill="none" />
        <line x1="18" y1="28" x2="46" y2="28" stroke={teal} strokeWidth="2" />
        <line x1="20.5" y1="21" x2="43.5" y2="21" stroke={teal} strokeWidth="1.6" />
        <line x1="20.5" y1="35" x2="43.5" y2="35" stroke={teal} strokeWidth="1.6" />
        {/* Box overlay */}
        <g>
          <path d="M32 40 L46 46 L46 56 L32 62 L18 56 L18 46 Z" fill={primary} />
          <path d="M32 40 L46 46 L32 52 L18 46 Z" fill={teal} />
          <path d="M32 52 L32 62 L18 56 L18 46 Z" fill={primary} opacity="0.85" />
        </g>
      </svg>
      {!compact && (
        <div className="leading-none">
          <div
            className="font-extrabold tracking-tight"
            style={{ fontFamily: "Sora, sans-serif", fontSize: line1, color: teal, letterSpacing: "0.02em" }}
          >
            WORLD WIDE
          </div>
          <div
            className="font-extrabold tracking-tight"
            style={{ fontFamily: "Sora, sans-serif", fontSize: line2, color: primary, lineHeight: 1.1 }}
          >
            WHOLESALE DEALS
            <span style={{ color: teal, fontSize: dense ? "9px" : "11px", verticalAlign: "super", marginLeft: 3 }}>LLC</span>
          </div>
        </div>
      )}
    </div>
  );
}
